import { useCallback, useEffect } from 'react';
import { off, on } from './helpers';

// Modified from:
// https://github.com/streamich/react-use/blob/master/docs/useBeforeUnload.md
export const useBeforeUnload = (
  isEnabled: boolean | (() => boolean) = true
) => {
  const handler = useCallback(
    (event: BeforeUnloadEvent) => {
      if (typeof isEnabled === 'function' ? isEnabled() : true) {
        event.preventDefault();
        event.returnValue = true;
      }
    },
    [isEnabled]
  );

  useEffect(() => {
    if (isEnabled) {
      on(window, 'beforeunload', handler);
      return () => off(window, 'beforeunload', handler);
    }
  }, [isEnabled, handler]);
};
